:host {
  position: absolute;
  z-index: 1000;
  display: block;

  .full {
    width: 100%;
    height: calc(100% - 60px);
    display: block;
    bottom: 0;
    right: 0;
    border-radius: 0;
    overflow-y: auto;

    @media screen and (max-width: 992px) {
      height: calc(100% - 60px);
    }
  }

  .background {
    background-size: cover;

    &--day {
      background: #163a96, url('waves.svg');
    }

    &--night {
      background: #163a96, url('waves.svg');
    }
  }

  .hide {
    display: none !important;
  }

  .helpdesk {
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 10000000;
    cursor: pointer;
    width: 50px;

    &--shop {
      @media screen and (max-width: 767px) {
        bottom: unset;
        top: 8px;
        left: max(176px, calc(50% - 50px));
        width: 50px;
      }
    }

    .helpdesk-layer {
      background: rgba(0, 0, 0, 0.4);
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .helpdesk-hover {
      display: block;
      height: 100px;
      width: 50px;
      position: absolute;
      bottom: 50px;
    }

    .helpdesk-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 50px;

      &__support,
      &__faq,
      &__chat {
        box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        border-radius: 50%;

        img {
          width: 100%;
          object-fit: contain;
        }
      }

      &__support {
        width: 50px;
        position: relative;
        z-index: 3;
        background: #0098ff;

        &--close {
          display: none;
        }
      }

      &__faq,
      &__chat {
        width: 20px;
        height: 20px;
        position: absolute;
        background: #0098ff;
        z-index: 1;
        right: 5px;
        bottom: 5px;

        span {
          width: 0;
          overflow: hidden;
        }

        img {
          position: relative;
          z-index: 3;
          padding: 10px;
          background: #0098ff;
          border-radius: 50%;
        }
      }

      &.open {
        .helpdesk-icon__support {
          background: #ed2c6e;

          &--open {
            display: none;
          }

          &--close {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            object-fit: contain;
          }
        }

        .helpdesk-icon__faq {
          transition: all 0.5s;
          // right: 20px;
          // bottom: 62px;
          right: 5px;
          bottom: 110px;

          &:hover {
            span {
              transition: all 0.3s;
              position: absolute;
              display: flex;
              align-items: center;
              width: auto;
              white-space: nowrap;
              right: 20px;
              background: white;
              border-radius: 20px 0 0 20px;
              bottom: 0;
              padding: 9px 40px 10px 15px;
              box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.1);
            }
          }
        }

        .helpdesk-icon__chat {
          transition: all 0.5s;
          // right: 64px;
          // bottom: 10px;
          right: 5px;
          bottom: 60px;

          &:hover {
            span {
              transition: all 0.3s;
              position: absolute;
              display: flex;
              align-items: center;
              width: auto;
              white-space: nowrap;
              right: 20px;
              background: white;
              background: var(--bg-primary);
              border-radius: 20px 0 0 20px;
              bottom: 0;
              padding: 9px 40px 10px 15px;
              box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.1);
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .helpdesk {
      .helpdesk--full {
        position: relative;
      }
    }
  }
}
